// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1cmH1","resendInfoText":"OnGoingPaymentBox_resendInfoText__3P6Kj"};